import { sharedLib } from "@shared/services/shared.service";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "app/rootReducer";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(sharedLib.baseApi.middleware),
  devTools: import.meta.env.DEV,
});

sharedLib.setupStore(store);
export default store;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
